import {
  SET_DATA_ROLES,
  SET_DATA_ROLES_LOADING_STATE,
  UPDATE_DATA_ROLES,
  DELETE_DATA_ROLES,
  BULK_UPDATE_DATA_ROLES,
  BULK_DELETE_DATA_ROLES,
} from '@/store/modules/data-governance/mutation-types';
import { axiosClient } from '@/core/services/http.service';

// Helper function to process role data and set userGuid from id if present
function processRoleData(data) {
  // Only send tagGuid and arrays of userGuid for each role
  const result = {};
  ['owners', 'governors', 'stewards'].forEach((roleKey) => {
    if (Array.isArray(data[roleKey])) {
      result[roleKey] = data[roleKey]
        .map(role => role.id || role.userGuid)
        .filter(Boolean);
    }
  });
  return result;
}

export async function getDataRoles({ commit }) {
  commit(SET_DATA_ROLES_LOADING_STATE, true);

  const { success, body } = await axiosClient.get('/api/dataroles');

  if (success) {
    body.forEach((item) => {
      item.selected = false; // Add selected property to each item
    });

    commit(SET_DATA_ROLES, body);
  } else {
    commit(SET_DATA_ROLES, []);
  }
  commit(SET_DATA_ROLES_LOADING_STATE, false);
}

export async function createOrUpdateDataRoles({ commit }, data) {
  commit(SET_DATA_ROLES_LOADING_STATE, true);
  
  // Process role data using the helper function
  const processedParams = processRoleData(data);
  processedParams.tagGuid = data.tagGuid; // Ensure tagGuid is included
  const { success } = await axiosClient.put(`/api/dataroles/${data.tagGuid}`, processedParams);

  if (success) {
    commit(UPDATE_DATA_ROLES, data);
  }
  commit(SET_DATA_ROLES_LOADING_STATE, false);
  return success;
}

export async function deleteDataRoles({ commit }, data) {
  commit(SET_DATA_ROLES_LOADING_STATE, true);
  const { success } = await axiosClient.delete(`/api/dataroles/${data.tagGuid}`);

  if (success) {
    commit(DELETE_DATA_ROLES, data.tagGuid);
  }
  commit(SET_DATA_ROLES_LOADING_STATE, false);
  return success;
}

export async function bulkUpdateDataRoles({ commit }, data) {
  commit(SET_DATA_ROLES_LOADING_STATE, true);
  
  // Process role data using the helper function
  const processedRoles = processRoleData(data.roles);
  // Build new array with tagGuid and non-empty owners/governors/stewards from proceesed roles
  const processedItems = data.items.map(item => {
    const newItem = { tagGuid: item.tagGuid };
    ['owners', 'governors', 'stewards'].forEach(key => {
      if (Array.isArray(processedRoles[key]) && processedRoles[key].length > 0) {
        newItem[key] = processedRoles[key];
      } else {
        newItem[key] = item[key].map(role => role.id || role.userGuid);
      }
    });
    return newItem;
  });
  const { success } = await axiosClient.put('/api/dataroles/bulk', processedItems);

  if (success) {
    commit(BULK_UPDATE_DATA_ROLES, data);
  }
  commit(SET_DATA_ROLES_LOADING_STATE, false);
  return success;
}

export async function bulkDeleteDataRoles({ commit }, data) {
  commit(SET_DATA_ROLES_LOADING_STATE, true);
  
  // Create array of tagGuids from the data
  const tagGuids = data.map(item => item.tagGuid);
 
  const { success } = await axiosClient.delete('/api/dataroles/bulk', {data: tagGuids});

  if (success) {
    commit(BULK_DELETE_DATA_ROLES, tagGuids);
  }
  commit(SET_DATA_ROLES_LOADING_STATE, false);
  return success;
}